import { useCallback } from "react";

import { useConnection } from "@/components/features/items/edit/_shared/ui/components/main/questions/connection/hooks";

import type { FormOptionType } from "@/components/ui/form/_types/type";

import { useProductPlanFormModelContext } from "../../../../context";
import { usePlanRoomStaticPrice } from "../../../price-and-policy/room-static-price/hooks";

import type { CheckedState } from "@radix-ui/react-checkbox";

export const usePlanAvailableRoomIDs = () => {
	const { viewModel, onSetViewModel, queryData } = useProductPlanFormModelContext();
	const { availableRoomIDs } = viewModel;
	const { roomNameAndIDOptions } = queryData.connection;

	const { inUse, initializeStaticPriceParams } = usePlanRoomStaticPrice();

	const {
		availableItemIDs,
		rawAvailableItemIDs,
		nameAndIDOptions,
		onSetAvailableItemIDs: _onSetAvailableItemIDs,
	} = useConnection<"availableRoomIDs">({
		availableItemIDs: availableRoomIDs, //
		nameAndIDOptions: roomNameAndIDOptions,
		keyOfValue: "availableRoomIDs",
		onSetViewModel,
	});

	const onSetAvailableItemIDs = useCallback(
		async (checkedState: CheckedState, item: FormOptionType) => {
			const newAvailableItemIDs = _onSetAvailableItemIDs(checkedState, item);

			if (inUse) {
				// 部屋に定額料金を設定している場合は、紐付けている部屋を変更した場合初期化する
				await initializeStaticPriceParams(newAvailableItemIDs.value.map((item) => item.value));
			}
		},
		[_onSetAvailableItemIDs, initializeStaticPriceParams, inUse],
	);

	return {
		availableItemIDs,
		rawAvailableItemIDs,
		nameAndIDOptions,
		onSetAvailableItemIDs,
	};
};
